import { useMenuDataJson } from '../../hooks/useMenuDataJson'
import './Footer.css'

const PEDIX_URL = 'https://pedix.app/mister-burger/'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { data } = useMenuDataJson()
  const locationInfo = data?.locationInfo || {
    address: '', phone: '', hours: '', whatsapp: ''
  }

  const scrollToSection = (id) => {
    const el = document.querySelector(`#${id}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const handleDirectionsClick = () => {
    const encodedAddress = encodeURIComponent(locationInfo.address)
    window.open(`https://maps.google.com/?q=${encodedAddress}`, '_blank', 'noopener,noreferrer')
  }

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola! Me gustaría hacer una reserva en Mister Burger')
    const rawPhone = locationInfo.whatsapp || ''
    const phoneDigitsOnly = rawPhone.replace(/\D/g, '')
    if (!phoneDigitsOnly) return

    const appUrl = `whatsapp://send?phone=${phoneDigitsOnly}&text=${message}`
    const webUrl = `https://wa.me/${phoneDigitsOnly}?text=${message}`
    const isMobile = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent)

    if (isMobile) {
      const fallbackTimer = setTimeout(() => {
        window.location.href = webUrl
      }, 800)
      try {
        window.location.href = appUrl
      } catch {
        clearTimeout(fallbackTimer)
        window.location.href = webUrl
      }
    } else {
      window.open(webUrl, '_blank', 'noopener,noreferrer')
    }
  }

  const handlePhoneClick = () => {
    const rawPhone = locationInfo.phone || ''
    const phoneDigitsOnly = rawPhone.replace(/\D/g, '')
    if (!phoneDigitsOnly) return
    window.location.href = `tel:${phoneDigitsOnly}`
  }

  const handleDeliveryClick = () => {
    window.open(PEDIX_URL, '_blank', 'noopener,noreferrer')
  }

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/_misteroficial/', '_blank', 'noopener,noreferrer')
  }

  return (
    <footer className="footer">
      <div className="footer-brand">
        <img src="/images/mister-logo.png" alt="Mister Burger" />
        <h3>Mister Burger. Por la noche en Catamarca.</h3>
      </div>

      <div className="footer-grid">
        <div className="footer-tile">
          <h5>Pedido</h5>
          <div>
            <button type="button" onClick={handleDeliveryClick}>Delivery</button>
            <button type="button" onClick={handleDeliveryClick}>Pick up</button>
            <button type="button" onClick={() => scrollToSection('menu')}>Menú</button>
          </div>
        </div>

        <div className="footer-tile">
          <h5>Local</h5>
          <div>
            <button type="button" onClick={handleDirectionsClick}>Mota Botello 320</button>
            <span>Catamarca</span>
            <span>{locationInfo.hours}</span>
          </div>
        </div>

        <div className="footer-tile">
          <h5>Contacto</h5>
          <div>
            <button type="button" onClick={handlePhoneClick}>{locationInfo.phone}</button>
            <button type="button" onClick={handleWhatsAppClick}>WhatsApp directo</button>
          </div>
        </div>

        <div className="footer-tile">
          <h5>Social</h5>
          <div>
            <button type="button" onClick={handleInstagramClick}>@_misteroficial</button>
            <span>San Fernando del Valle de Catamarca</span>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{currentYear} Mister Burger</span>
          <span>Hecho en Catamarca</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
